<template>
  <div>
    <v-row class="ma-0">
      <strong class="mt-2 mr-2">メールアドレス</strong>
      <v-text-field v-model.trim="keyword" hide-details dense :placeholder="$t('keyword-title')"
        class="max-width-3 mr-3 rounded-xl" outlined @keydown.enter="search" prepend-inner-icon="mdi-magnify"
        autofocus />
      <v-btn color="primary" @click="search">{{ $t("search-title") }}</v-btn>
      <v-spacer />
      <v-btn color="success" @click="dialogCreateTeacher = true">新規登録</v-btn>
    </v-row>
    <v-layout class="row mx-1 mt-5" child-flex>
      <v-data-table :headers="headers" fixed-header :items="listTeacher" :loading="loaddingListTeacher"
        :items-per-page.sync="pagination.maxResultCount" :page="pagination.page" loading-text="読み込み中。。。待ってください。"
        hide-default-footer class="elevation-1">
        <template v-slot:item.email="{ item: { email, Id, username } }">
          <router-link :to="{
            name: 'Detail Teacher',
            params: { id: Id, username: username },
          }">{{ email ? email : Id }}</router-link>
        </template>
        <template v-slot:item.approved="{ item }">
          <v-chip small :color="item.approved == 'CONFIRMED' ? 'success' : 'default'"
            class="text-capitalize font-weight-medium" style="min-width: 94px; justify-content: center">{{ item.approved
                | checkApproved
            }}</v-chip>
        </template>
        <template v-slot:item.active="{ item }">
          <v-chip small :color="item.active ? 'success' : 'default'" class="text-capitalize font-weight-medium"
            style="min-width: 94px; justify-content: center">{{
                item.active ? $t("active-title") : $t("inactive-title")
            }}</v-chip>
        </template>
        <template v-slot:item.last_login="{ item }">{{
            item.last_login
              ? $moment(item.last_login).format("YYYY-MM-DD HH:mm")
              : null
        }}</template>

        <template v-slot:item.actions="{ item }">
          <v-btn small class="mr-2" :to="{
            name: 'Activity log teacher',
            params: { id: item.Id },
            query: { username: item.email, email: item.email },
          }">アクティビティログ</v-btn>
          <v-btn small color="error" v-if="item.active" @click="handleShowDialogBAN(item)">BAN</v-btn>
        </template>
        <template v-slot:no-data>
          <div class="text-center">データがありません。</div>
        </template>
      </v-data-table>
    </v-layout>
    <v-row class="mx-1 mt-2">
      <strong class="mt-4 mr-2">表示件数</strong>
      <v-select class="max-width-1 mt-2" hide-details :items="recordsPage" v-model="pagination.maxResultCount" dense
        outlined @change="handleChangeResultCount" />
      <v-spacer />
      <BasePagination v-if="listTeacher.length > 0" class="mt-5" :pageCount="listTeacher.length"
        :pageSize="pagination.maxResultCount" @changePage="(value) => (pagination.page = value)" />
      <DialogCreateTeacher v-model="dialogCreateTeacher" @resetList="handleGetListTeacher" :key="dialogCreateTeacher" />
    </v-row>
    <!-- dialog confirm ban teacher  -->
    <v-dialog v-model="dialogConfirmBANTeacher" width="380">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-2">確認</v-card-title>
        <v-card-text class="mt-2">{{
            $t("ban-conten", { name: userBan.email })
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="error" :loading="loaddingBANTeacher" @click="handleBANTeacher">OK</v-btn>
          <v-btn small color @click="dialogConfirmBANTeacher = false">キャンセル</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import mixin from "@/mixin";
import BasePagination from "@/components/Pagination/BasePagination";
import DialogCreateTeacher from "@/views/Teacher/DialogCreateTeacher.vue";
import { getListTeacher, banTeacher, search } from "@/api/Teacher.api";
export default {
  mixins: [mixin.App, mixin.Auth, mixin.ValidateCreate],
  components: {
    BasePagination,
    DialogCreateTeacher,
  },
  data() {
    return {
      keyword: "",
      listTeacher: [],
      loaddingListTeacher: false,
      dialogCreateTeacher: false,
      dialogConfirmBANTeacher: false,
      loaddingBANTeacher: false,
      keyDialogCreateTeacher: 0,
      searchResultExists: false,
      userBan: {},
      headers: [
        {
          text: "No.",
          align: "start",
          value: "no",
        },
        { text: "メールアドレス", value: "email" },
        { text: this.$i18n.t("lesson-count-title"), value: "lesson_count" },
        {
          text: this.$i18n.t("lesson-count-cancel-title"),
          value: "lesson_count_cancel",
        },
        { text: "先月のレッスン回数", value: "lesson_finished" },
        { text: "ステータス", value: "approved" },
        { text: this.$i18n.t("approve-title"), value: "active" },
        {
          text: this.$i18n.t("action-title"),
          value: "actions",
          width: "245px",
        },
      ],
    };
  },
  filters: {
    checkApproved(value) {
      let approve = value == "NOT_CONFIRM" ? "未確認" : value == "WAITING_CONFIRM" ? "確認中" : "確認済み"
      return approve
    }
  },
  watch: {
    dialogCreateTeacher: function () {
      this.keyDialogCreateTeacher++;
    },
    "pagination.maxResultCount": function () {
      this.pagination.page = 1;
    },
  },
  created() {
    this.handleGetListTeacher();
  },
  methods: {
    handleChangeResultCount() {
      if (this.searchResultExists == true) {
        this.listTeacher.forEach((item, index) => {
          item.no = index + 1;
        });
      }
    },
    async handleGetListTeacher() {
      this.dialogCreateTeacher = false;
      this.loaddingListTeacher = true;
      this.keyDialogCreateTeacher++;
      await getListTeacher().then((response) => {
        this.listTeacher = response.result;
        this.listTeacher.forEach((item, index) => {
          item.no = index + 1;
        });
        this.pagination.pageCount = response.totalCount;
      });
      this.loaddingListTeacher = false;
    },
    async handleSearch(value) {
      this.dialogCreateTeacher = false;
      this.loaddingListTeacher = true;
      this.keyDialogCreateTeacher++;
      const params = {
        keyword: value,
      };
      await search(params).then((response) => {
        this.listTeacher = response.result;
        this.listTeacher.forEach((item, index) => {
          item.no = index + 1;
        });
        this.pagination.pageCount = response.totalCount;
      });
      this.loaddingListTeacher = false;
    },
    async search() {
      const { keyword } = this;
      if (keyword != null && keyword != "") {
        this.searchResultExists = true;
        await this.handleSearch(keyword);
        this.listTeacher = this.listTeacher.filter((item) =>
          item.email
            .toString()
            .toLowerCase()
            .includes(keyword.toString().toLowerCase())
        );
        this.listTeacher.forEach((item, index) => {
          let newIndex = index + 1;
          if ((newIndex % this.pagination.maxResultCount) != 0) {
            item.no = newIndex % this.pagination.maxResultCount;
          } else {
            item.no = this.pagination.maxResultCount;
          }
        });
        this.pagination.pageCount = this.listTeacher.length;
      } else {
        this.searchResultExists = false;
        this.handleGetListTeacher();
      }
      this.pagination.page = 1;
    },
    handleShowDialogBAN(item) {
      this.userBan = item;
      this.dialogConfirmBANTeacher = true;
    },
    async handleBANTeacher() {
      this.loaddingBANTeacher = true;
      const { username, Id } = this.userBan;
      await this.handleDisableUser(username)
        .then(async () => {
          let params = {
            username,
            teacher_id: Id,
          };
          await banTeacher(params)
            .then(() => {
              this.dialogConfirmBANTeacher = false;
              this.handleGetListTeacher();
            })
            .catch((err) => {
              this.$toast.error(err);
            });
        })
        .catch(this.$toast.errors);
      this.loaddingBANTeacher = false;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>